import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

export const Loading = ({ children }) => {
  const statusLoading = useSelector(state => state.app.statusLoading);

  const antIcon = <LoadingOutlined style={{ fontSize: 50, marginTop: '13%' }} spin />;

  return (
    <Spin
      style={{ position: 'fixed' }}
      indicator={antIcon}
      size="large"
      spinning={statusLoading}
      id="ComponenteLoading"
      data-testid="Componente Loading"
    >
      {children}
    </Spin>
  );
};

Loading.propTypes = {
  children: PropTypes.any,
};

export default Loading;
